import React from "react";
import { Row } from "react-bootstrap";

const SettingsRow = ({ Icon, text, Setting }) => {
  return (
    <Row className="justify-content-between">
      <span className="d-flex align-items-center w-auto">
        <h6 className="w-auto m-0">
          <Icon className="me-2" size={16} />
          {text}
        </h6>
      </span>
      <span className="d-flex w-auto">
        <Setting />
      </span>
    </Row>
  );
};

export default SettingsRow;
